export const videoTypes = {
    UIPATH: 'uiPath',
    AUTOMATIONANYWHERE: 'automationAnywhere',
    POWERBI: 'powerBi',
    TABLEAUSOFTWARE: "tableauSoftware",
    WEBINAR: "webinar",
    PODCAST: "podcast"
}